module.exports = __webpack_public_path__ + "static/media/Escavalier_gaussian2.7a8b91fe.png";